import config from '../package.json';

const ID = `${config.name}/actions/luckydrawAction`;
const createActionName = (name: string) => `app/${ID}/${name}`;

export const DEEPLINK_TO_LUCKYDRAW = createActionName('DEEPLINK_TO_LUCKYDRAW');
export const DEEPLINK_TO_LUCKYDRAW_SUCCESS = createActionName(
  'DEEPLINK_TO_LUCKYDRAW_SUCCESS',
);
export const DEEPLINK_TO_LUCKYDRAW_FAILURE = createActionName(
  'DEEPLINK_TO_LUCKYDRAW_FAILURE',
);

export const deepLinkToLuckydraw = (query: string) => {
  return {
    type: DEEPLINK_TO_LUCKYDRAW,
    payload: { query },
  };
};
